import React, { LinkHTMLAttributes } from 'react';
import styled from 'styled-components';

import Link from './Link';

export interface GridItemProps extends LinkHTMLAttributes<HTMLAnchorElement> {
  icon: string;
}

function GridItem(props: GridItemProps) {
  const { icon, children, ...restProps } = props;
  return (
    <ItemBase {...restProps}>
      {icon && <Icon aria-hidden>{icon}</Icon>}
      {children}
    </ItemBase>
  );
}

const ItemBase = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const Icon = styled.i`
  font-size: 22px;
  width: 22px;
  height: 22px;
`;

export default GridItem;
